import { render, staticRenderFns } from "./LmncTable.vue?vue&type=template&id=4dd69ab9&scoped=true&"
import script from "./LmncTable.vue?vue&type=script&lang=js&"
export * from "./LmncTable.vue?vue&type=script&lang=js&"
import style0 from "./LmncTable.vue?vue&type=style&index=0&id=4dd69ab9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd69ab9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})
